<template >

  <div class="">
    <el-col :span="18">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home/businessManagement' }">商家管理</el-breadcrumb-item>
        <el-breadcrumb-item>商家活动</el-breadcrumb-item>
      </el-breadcrumb>
    </el-col>
    <el-col :span="18" class="basic-margin">
      <list-template
        ref="list-template"
        :hasSearch="false"
        actionUrl="business/findBusinessActives.action"
        :queryParams="searchInfo">

        <template slot="searchButton" scope="scope">

          <el-button type="primary" style="margin-right:20px;" @click="toReleaseActive()">发布活动</el-button>

        </template>

        <template slot="item" scope="scope">

          <div >
            <el-card  class="basic-margin" v-for="data in scope.datas">
              <el-row>
                <el-col :span="2" style="text-align:left;margin-left:20px;">
                </el-col>
                <el-col :span="14" style="text-align:left;margin-left:20px;">
                  <p style="font-size:1.8rem;">{{data.activityName}}</p>
                  <p style="color:#666;font-size:1.4rem;margin-top:10pt;">活动周期:{{data.startTime| dateFormat}}至{{data.endTime| dateFormat}}</p>
                  <p style="color:#666;font-size:1.4rem;margin-top:20pt;"> {{data.createTime | dateFormat}} </p>
                </el-col>

                <el-col :span="4" style="text-align:left;margin-left:20px;">
                  <el-button v-delete="{id:data.id,action:'business/deleteBusinessActive.action'}">删除</el-button>
                  <el-button type="primary" @click="toEditActive(data.id)">编辑</el-button>
                </el-col>
              </el-row>
            </el-card>
          </div>

        </template>
      </list-template>
    </el-col>
  </div>

</template>
<style scpoed >
	.top-margin{
		margin-left:5px
	}
</style>

<script>
import BusinessModel from '../../../framework/models/businessModel'
import Config from '../../../framework/configs/Config'
import BasicPager from '../../../mixins/BasicPager'
import ListTemplate from '../../../components/ListTemplate'
export default {
  name: 'thematic-management',
  extends: BasicPager,
  data: function () {
    return {
      datas: [],
      searchInfo: {
        businessId: null,
        keyword: ''
      },
      currentPage: 1, // 起始
      pageSize: 10, // 步长
      totalCount: 0, // 总条数
      dialogVisible: false,
      imageUrl: Config.imageUrl
    }
  },
  components: {
    BusinessModel,
    ListTemplate
  },
  created: function () {
    let that = this
    let params = this.$route.params
    that.searchInfo.businessId = params.businessId
  },
  methods: {
    toReleaseActive: function () {
      this.$router.push({ name: '添加活动', params: { businessId: this.searchInfo.businessId } })
    },
    toEditActive: function (id) {
      this.$router.push({ name: '编辑活动', params: { businessId: this.searchInfo.businessId, businessActiveId: id } })
    }
  }
}
</script>
